import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { CircleAnimatedButton } from '@vlabs/uikit';
import type { CircleAnimatedButtonProps } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useGoToEventDetailsTranslation } from './i18n';
import type { GoToEventDetailsProps } from './types';
import { buildTestid } from '../../shared/lib/utils';

interface GoToEventDetailsCircleAnimatedButtonProps extends GoToEventDetailsProps, Omit<CircleAnimatedButtonProps, 'children' | 'icon'> {
  title?: string;
}

const displayName = 'GoToEventDetailsCircleAnimatedButton';
const testid = buildTestid(displayName);

function GoToEventDetailsCircleAnimatedButton({
  eventId,
  title = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToEventDetailsCircleAnimatedButtonProps): React.JSX.Element {
  const { t } = useGoToEventDetailsTranslation();

  return (
    <CircleAnimatedButton
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      to={generatePath(routes.events.eventDetails, { eventId })}
      {...testid(dataTestId)}
      {...props}
    >
      {title ?? t('title')}
    </CircleAnimatedButton>
  );
}

GoToEventDetailsCircleAnimatedButton.displayName = displayName;

export { GoToEventDetailsCircleAnimatedButton };
